__turbopack_context__.v({
  "footer": "CardFormFooter-module-scss-module__pnF5rW__footer",
});
